import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../../../utils/general'

const useActivityColumns = () => {
    const { t } = useTranslation()

    const columns = [
        {
            header: t('app.common.id'),
            id: 'contact',
            enableSorting: false,
            size: 50,
            cell: ({ row }) => {
                const contactId = row.original?.contact?.internalAppId ?? ''
                const companyId = row.original?.contactCompany?.[0]?.internalAppId ?? ''

                return contactId || companyId
            },
        },
        {
            header: t('app.common.activityType'),
            id: 'title',
            enableSorting: false,
            size: 130,
            cell: ({ row }) => row.original?.activityType?.name,
        },
        {
            header: t('app.common.activityStatus'),
            id: 'completed',
            enableSorting: false,
            size: 130,
            cell: ({ row }) =>
                row.original?.completed ? t('table.opportunityList.activityStatus.completed') : t('table.opportunityList.activityStatus.open'),
        },
        {
            header: t('table.header.opportunityList.dateFrom'),
            id: 'dateFrom',
            enableSorting: false,
            size: 145,
            cell: ({ row }) => formatDateTime(row.original?.dateFrom),
        },
        {
            header: t('app.common.contact.nameAndSurname'),
            id: 'contactPersonName',
            enableSorting: false,
            size: 235,
            cell: ({ row }) => {
                const contactPerson = row.original?.contact?.contactPerson
                return `${contactPerson?.firstName ?? ''} ${contactPerson?.lastName ?? ''}`
            },
        },
        {
            header: t('app.common.company.name'),
            id: 'contactCompanyName',
            enableSorting: false,
            size: 180,
            cell: ({ row }) => {
                // contactPersonCompanyName - name of company related to person
                // contactPersonCompanyName2 - TODO: this path might be backend issue on activity response, should be same as contactPersonCompanyName
                // contactCompanyName - name of standalone company
                const contactPersonCompanyName = row.original?.contact?.contactPersonCompany?.[0]?.company?.contactCompany?.name ?? ''
                const contactPersonCompanyName2 = row.original?.contact?.contactCompany?.name ?? ''
                const contactCompanyName = row.original?.contactCompany?.[0]?.contactCompany?.name ?? ''

                return contactPersonCompanyName || contactCompanyName || contactPersonCompanyName2
            },
        },
        {
            header: t('app.common.contactPhoneNumber1'),
            id: 'contactPhone',
            enableSorting: false,
            size: 135,
            cell: ({ row }) => {
                const contactPhone = row.original?.contact?.contactPhone?.[0]?.phoneNumber ?? ''
                const companyPhone = row.original?.contactCompany?.[0]?.contactPhone?.[0]?.phoneNumber ?? ''

                return contactPhone || companyPhone
            },
        },
        {
            header: t('app.common.email.label'),
            id: 'contactEmail',
            enableSorting: false,
            size: 280,
            cell: ({ row }) => {
                const contactEmail = row.original?.contact?.contactEmail?.[0]?.email ?? ''
                const companyEmail = row.original?.contactCompany?.[0]?.contactEmail?.[0]?.email ?? ''

                return contactEmail || companyEmail
            },
        },
        {
            header: t('app.common.agent'),
            id: 'agent',
            enableSorting: false,
            size: 200,
            cell: ({ row }) => {
                const agent = row.original?.activityAgent?.[0]?.agent
                if (!agent) return ''
                return `${agent.firstName ?? ''} ${agent.lastName ?? ''}`
            },
        },
        {
            id: 'actions',
            enableSorting: false,
            size: 40,
            meta: { tdClass: 'text-center' },
            cell: ({ row }) => {
                // contactId - id of contact (person)
                // contactPersonCompanyId - id of company related to person
                // companyId - id of standalone company
                const contactId = row.original?.contact?.id
                const contactPersonCompanyId = row.original?.contact?.id
                const companyId = row.original?.contactCompany?.[0]?.id
                const link = row.original?.contact?.contactPerson ? `/contacts/${contactId}` : `/companies/${companyId || contactPersonCompanyId}`

                return (
                    <ul className="list-inline hstack gap-2 mb-0 justify-content-center">
                        <li className="list-inline-item edit">
                            {(contactId || companyId) && (
                                <Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={t('button.view')}
                                    to={link}
                                    className="text-info d-inline-block edit-item-btn"
                                >
                                    <i className="mdi mdi-eye-outline fs-16"></i>
                                </Link>
                            )}
                        </li>
                    </ul>
                )
            },
        },
    ]

    return columns
}

export default useActivityColumns
